import React from "react";
import UsersTableFilterStrip from "./UsersTableFilterStrip";

/**
 * Shared Team / Users filter row: divider strip on the left, primary actions on the right.
 */
export default function TeamUsersFilterToolbar({
  filters,
  values,
  onChange,
  onClear,
  showClearFilters = false,
  actions = null,
  className = "",
}) {
  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-x-3 gap-y-2 ${className}`}
    >
      <UsersTableFilterStrip
        filters={filters}
        values={values}
        onChange={onChange}
        onClear={onClear}
        showClearFilters={showClearFilters}
      />
      {actions ? <div className="ml-auto flex items-center gap-3">{actions}</div> : null}
    </div>
  );
}
